// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2gvxD","left":"InfoRow_left__1_9I-"};